import React from 'react';
import classNames from 'classnames';
import { AspectRatioBox, AspectRatioBoxProps } from '@moda/om';
import { Image, ImageProps } from '../Image';

import './ResponsiveImage.scss';

export type ResponsiveImageProps = ImageProps & AspectRatioBoxProps;

export const ResponsiveImage: React.FC<ResponsiveImageProps> = ({
  maxHeight,
  maxWidth,
  aspectHeight,
  aspectWidth,
  className,
  ...rest
}) => (
  <AspectRatioBox
    className={classNames('ResponsiveImage', className)}
    {...{ maxHeight, maxWidth, aspectHeight, aspectWidth }}
  >
    <Image className="ResponsiveImage__image" maxWidth={maxWidth} maxHeight={maxHeight} {...rest} />
  </AspectRatioBox>
);
